'use strict';

const $ = require('jquery');
const cookies = require('js-cookie');
const isString = require('lodash/isString');
const get = require('lodash/get');

const COOKIES = {
    LOGGED_IN: '_bo_logged_in',
    FIRST_NAME: 'bo_first_name',
};

const SELECTORS = {
    CONTAINER: '.global-nav-logout',
    NAME: '.global-nav-logout__name',
};

const CLASSES = {
    HIDDEN: 'global-nav-logout--hidden',
};

// Are we on BlocksOffice?
const is_blocksoffice = get(window, 'is_blocksoffice', false);

function init() {
    if (is_blocksoffice) {
        return false;
    }

    const container = $(SELECTORS.CONTAINER);

    if (!container.length) {
        return false;
    }

    const loggedInCookie = cookies.get(COOKIES.LOGGED_IN);
    const firstNameCookie = cookies.get(COOKIES.FIRST_NAME);

    const isLoggedIn = (
        parseInt(loggedInCookie, 10) === 1 &&
        isString(firstNameCookie) && firstNameCookie.length
    );

    if (isLoggedIn === false) {
        if (container.hasClass(CLASSES.HIDDEN) === false) {
            container.addClass(CLASSES.HIDDEN);
        }

        return false;
    }

    $(SELECTORS.NAME).text(firstNameCookie);

    container.removeClass(CLASSES.HIDDEN);
}

module.exports = {
    init
};



// WEBPACK FOOTER //
// ./modules/logout.js